module.exports = __webpack_public_path__ + "assets/travel_tracker_primary.e02d0726.svg";